import React from 'react';

interface LinkifyTextProps {
    children: string;
    className?: string;
}

const LinkifyText: React.FC<LinkifyTextProps> = ({ children, className }) => {
    // Simple URL regex pattern
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const linkifyText = (text: string) => {
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (urlRegex.test(part)) {
                return (
                    <a
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={className}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    return <>{linkifyText(children)}</>;
};

export default LinkifyText; 